import React, {Component} from 'react';
import './Group.css';
import moment from "moment";

class DoubleDate extends Component {

    render() {
        if (!this.props.entry.fields[this.props.format.first.field]
            || !this.props.entry.fields[this.props.format.second.field]) {
            return null;
        }

        const dateStart = moment(this.props.entry.fields[this.props.format.first.field]);
        const dateEnd = moment(this.props.entry.fields[this.props.format.second.field]);

        if (dateStart.format(this.props.format.first.format) == dateEnd.format(this.props.format.second.format)) {
            return (
                <p>
                    <span><i className={this.props.format.icon}/> {this.props.format.label} :</span>
                    <b>{dateStart.format(this.props.format.first.format)}</b>
                </p>
            );
        } else {
            return (
                <p>
                    <span><i className={this.props.format.icon}/> {this.props.format.label} :</span>
                    <b>{dateStart.format(this.props.format.first.format)} - {dateEnd.format(this.props.format.second.format)}</b>
                </p>
            );
        }

    }
}

export default DoubleDate;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCards/DoubleDate.js